export class OverlayDeleteParticipant {
  constructor(el) {
    this.el = el;
    this.overlay = document.querySelector("[data-overlay-delete]");
    // this.yesButton = document.querySelector("[data-delete-yes]");
    this.noButton = this.overlay.querySelector("[data-action='no']");

    this.close = this.close.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClickDispatch = this.onClickDispatch.bind(this);

    this.el.addEventListener("click", this.onClick);
  }

  onClick(e) {
    this.open();

    e.preventDefault();
  }

  open() {
    document.documentElement.classList.add("overlay-delete-is-active");

    this.overlay.addEventListener("click", this.onClickDispatch);
  }

  onClickDispatch(e) {
    var target = e.target;

    if (target.dataset.action == "yes") {
      window.location.href = this.el.href;
    } else if (target.dataset.action == "no") {
      this.close();
    }
  }

  close() {
    this.overlay.removeEventListener("click", this.onClickDispatch);
    document.documentElement.classList.remove("overlay-delete-is-active");
  }
}
